//'https://localhost:5001/'
export const settings = {
    baseUrl: process.env.REACT_APP_API_URL ,
    prodUrl: 'https://api.madfreightapi.com/',
    testUrl: 'https://localhost:5001/'
}